module.exports = __webpack_public_path__ + "img/upsuccess.88206a26.svg";